<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-3 searching">
                                <span class="h_page">Tujuan SKPD</span> <br> <br>
                            </div>
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button @click="btn_check_data_add()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                                    </span>
                                    <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">

                            <div class="col-md-4">
                                <span class="huruf_input">Unit Kerja</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>
                            <div class="col-md-4">
                                <span class="huruf_input">Periode Renstra</span>
                                <select @change="getRenstraMisi()" class="form-control show-tick" v-model="id_renstra">
                                    <option value="" >-- Semua Periode --</option>
                                    <option v-for="data in list_Renstra" :key="data.id_renstra" :value="data.id_renstra">{{data.periode}}</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <span class="huruf_input">Misi SKPD</span>
                                <select @change="cari_data()" class="form-control show-tick" v-model="renstra_misi_id">
                                    <option value="" >-- Semua Misi --</option>
                                    <option v-for="data in list_Renstra_Misi" :key="data.renstra_misi_id" :value="data.renstra_misi_id">[{{data.nomor_renstra_misi}}] {{data.uraian}}</option>
                                </select>
                            </div>


                        </div>
                        <br>
                        
                        <br>
                        <div class="table-responsive">
                            <table class="table table-bordered" style="width: 100%">
                                <thead>
                                <tr class="bg-success kepala_table_f tabel_center">
                                    <th class="text-center" style="width: 5%">Kode.</th>
                                    <th class="text-center" style="width: 40%">Tujuan SKPD</th>
                                    <th class="text-center" style="width: 40%">Tujuan RPJMD</th>
                                    <th class="text-center" style="width: 15%">#</th>
                                </tr>
                                </thead>
                                <tbody class="tabel_center" >
                                <tr class="h_isitable" v-for="data in list_data" :key="data.renstra_tujuan_id">
                                    <td class="tabel_center text-center"  :style="cek_error_data(data.nomor_renstra_misi)">{{data.nomor_renstra_misi}}.{{data.no_renstra_tujuan}}</td>
                                    <td class="tabel_center">{{data.uraian}}</td>
                                    <td class="tabel_center">[{{data.kode}}]&nbsp; &nbsp;{{data.tujuan_uraian}}</td>

                                    <td class="tabel_center text-center" >
                                        <button @click="selectData(data)" class="btn bg-light-blue btn-xs waves-effect" title="Tambah Indikator" id="edit_data" data-toggle="modal" data-target="#m_indikator_tujuan">
                                            <i class="material-icons" >control_point</i>
                                        </button>
                                        &nbsp;
                                        <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                            <i class="material-icons" >create</i>
                                        </button>
                                        &nbsp;
                                        <button @click="removeData(data.renstra_tujuan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                            <i class="material-icons" >clear</i>
                                        </button>

                                    </td>
                                </tr>

                                </tbody>
                            </table>
                        </div>

                        <hr>
                            <div class="text-center">
                                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                                    <i class="material-icons">skip_previous</i>
                                </button>
                                &nbsp;
                                <span style="font-size: 85%; color: #a5a5a5">
                                    <b>{{page_first}} - {{page_last}}</b>
                                </span>
                                &nbsp;
                                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                                    <i class="material-icons">skip_next</i>
                                </button>
                            </div>
                        <hr>
                <!-- ============================================================ MULAI ======================================================================== -->





                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                        </div>

                                        <form @submit.prevent="addData()">

                                            <div class="modal-body">
                                                <div v-if="!check_data_add" class="alert alert-info text-center">
                                                    <strong>SILAHKAN PILIH PERIODE RENSTRA DAN MISI SKPD TERLEBIH DAHULU!</strong> 
                                                </div>

                                                <div v-if="check_data_add">

                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Periode Rpjmd</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <select class="form-control show-tick" v-model="rpjmd_id" @change="getTujuan">
                                                                        <option value="" >-- Pilih Periode --</option>
                                                                        <option v-for="data in list_RPJMD" :key="data.rpjmd_id" :value="data.rpjmd_id">{{data.periode}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Tujuan RPJMD</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <select class="form-control show-tick" v-model="tujuan_id">
                                                                        <option value="" >-- Pilih Tujuan --</option>
                                                                        <option v-for="data in list_tujuan" :key="data.tujuan_id" :value="data.tujuan_id">[{{data.kode}}] {{data.uraian}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">No Tujuan SKPD</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <input :required="true" v-model="no_renstra_tujuan" type="number" class="datepicker form-control" >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Uraian </label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <input v-model="uraian" type="text" class="datepicker form-control" >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Keterangan </label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <textarea :required="true" v-model="keterangan" rows="4" class="form-control no-resize"></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-green">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                        </div>
                                        <form @submit.prevent="editData()">
                                            <div class="modal-body">
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Periode Rpjmd</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <select class="form-control show-tick" v-model="rpjmd_id" @change="getTujuan">
                                                                    <option value="" >-- Pilih Periode --</option>
                                                                    <option v-for="data in list_RPJMD" :key="data.rpjmd_id" :value="data.rpjmd_id">{{data.periode}}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Tujuan RPJMD</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <select class="form-control show-tick" v-model="tujuan_id">
                                                                    <option value="" >-- Pilih Tujuan --</option>
                                                                    <option v-for="data in list_tujuan" :key="data.tujuan_id" :value="data.tujuan_id">[{{data.kode}}] {{data.uraian}}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Renstra Misi ID</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <select @change="cari_data()" class="form-control show-tick" v-model="renstra_misi_id_edit">
                                                                    <option value="" >-- Semua Misi --</option>
                                                                    <option v-for="data in list_Renstra_Misi" :key="data.renstra_misi_id" :value="data.renstra_misi_id">[{{data.nomor_renstra_misi}}] {{data.uraian}}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">No Tujuan SKPD</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input :required="true" v-model="no_renstra_tujuan" type="number" class="datepicker form-control" >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Uraian </label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="uraian" type="text" class="datepicker form-control" >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Keterangan </label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <textarea :required="true" v-model="keterangan" rows="4" class="form-control no-resize"></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL INDIKATOR TUJUAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_indikator_tujuan" tabindex="-1" role="dialog" data-backdrop='static'>
                                <div class="modal-dialog modal-xlg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">Indikator Tujuan</h4>
                                        </div>
                                            <div class="modal-body">

                                                <button class="btn btn-info" data-toggle="modal" data-target="#m_indikator_tujuan_tambah">TAMBAH INDIKATOR</button>
                                                <hr>
                                                <div class="table-responsive">
                                                    <table class="table table-bordered" style="width: 100%">
                                                        <thead>
                                                        <tr class="bg-info kepala_table_f tabel_center">
                                                            <th class="text-center" style="width: 5%">Kode</th>
                                                            <th class="text-center" style="width: 40%">Indikator</th>
                                                            <th class="text-center" style="width: 8%">Satuan</th>
                                                            <th class="text-center" style="width: 15%">Rumusan Satuan</th>
                                                            <th class="text-center" style="width: 10%">Capaian Awal</th>
                                                            <th class="text-center" style="width: 10%" >Kondisi Akhir</th>
                                                            <th class="text-center" style="width: 12%">#</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody class="tabel_center" >
                                                        <tr class="h_isitable" v-for="data in list_indikator" :key="data.renstra_indikator_tujuan_id">
                                                            <td class="tabel_center text-center">{{data.no_indikator}}</td>
                                                            <td class="tabel_center" >{{data.uraian}}</td>
                                                            <td class="tabel_center" >{{data.satuan}}</td>
                                                            <td class="tabel_center">{{data.rumus_satuan}}</td>
                                                            <td class="tabel_center text-center" >{{data.capaian_awal}}</td>
                                                            <td class="tabel_center text-center" >{{data.kondisi_akhir}}</td>
                                                            <td class="tabel_center text-center" >

                                                                <button @click="selectIndikator(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" data-toggle="modal" data-target="#m_indikator_tujuan_edit">
                                                                    <i class="material-icons" >create</i>
                                                                </button>
                                                                &nbsp;
                                                                <button @click="removeDataIndikator(data.renstra_indikator_tujuan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                                    <i class="material-icons" >clear</i>
                                                                </button>

                                                            </td>
                                                        </tr>

                                                        </tbody>
                                                    </table>

                                                </div>


                                            </div>
                                            <div class="modal-footer">
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL INDIKATOR TUJUAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL INDIKATOR TUJUAN TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_indikator_tujuan_tambah" tabindex="-1" role="dialog" data-backdrop='static'>
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">Tambah Indikator Tujuan</h4>
                                        </div>
                                        <form @submit.prevent="addIndikator()">
                                            <div class="modal-body">
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">No</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="no_indikator" :required="true" type="number" class="form-control" placeholder="Ex : 1">
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Uraian</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="uraian_indikator" :required="true" type="text" class="form-control">
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Satuan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="satuan" :required="true" type="text" class="form-control">
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Rumusan Satuan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="rumus_satuan" :required="true" type="text" class="form-control">
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Capaian Awal</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="capaian_awal" :required="true" type="number" class="form-control" placeholder="Ex : 1">
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Kondisi Akhir</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="kondisi_akhir" :required="true" type="number" class="form-control" placeholder="Ex : 5">
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>



                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">SIMPAN</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL INDIKATOR TUJUAN TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL INDIKATOR TUJUAN EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_indikator_tujuan_edit" tabindex="-1" role="dialog" data-backdrop='static'>
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">Edit Indikator Tujuan</h4>
                                        </div>
                                        <form @submit.prevent="editIndikator()">
                                            <div class="modal-body">
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">No</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="no_indikator" :required="true" type="number" class="form-control" placeholder="Ex : 1">
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Uraian</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="uraian_indikator" :required="true" type="text" class="form-control">
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Satuan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="satuan" :required="true" type="text" class="form-control">
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Rumusan Satuan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="rumus_satuan" :required="true" type="text" class="form-control">
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Capaian Awal</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="capaian_awal" :required="true" type="number" class="form-control" placeholder="Ex : 1">
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Kondisi Akhir</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="kondisi_akhir" :required="true" type="number" class="form-control" placeholder="Ex : 5">
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>



                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL INDIKATOR TUJUAN EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->



                    </div>

                </div>

            </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_renstra_tujuan/';
    const ADD_URL_RENSTRA = URL_APP+'api/v1/planning_renstra_renstra/';
    const ADD_URL_RENSTRA_MISI = URL_APP+'api/v1/planning_renstra_misi/';
    const ADD_URL_UNIT_KERJA = URL_APP+'api/v1/simpeg_unit_kerja/';
    const URL_SERVER = URL_APP;

    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';
    const ADD_URL_TUJUAN = URL_APP+'api/v1/planning_tujuan/';

    import Autocomplete from 'vue2-autocomplete-js'

    


    export default {
        name: "planning_rpjmd",
        components: { Autocomplete },
        data() {
            return {
                renstra_tujuan_id : '',

                rpjmd_id : '',
                tujuan_id : '',

                id_renstra : '',
                renstra_misi_id : '',
                renstra_misi_id_edit : '',

                no_renstra_tujuan : 0,
                uraian : '',
                keterangan : '',

                unit_kerja : '',
                unit_kerja_full : '',
                unit_kerja_edit : '',

                check_data_add : false,

                renstra_indikator_tujuan_id: '',
                no_indikator : '',
                uraian_indikator : '',
                satuan : '',
                rumus_satuan : '',
                capaian_awal : '',
                kondisi_akhir : '',
                

                list_indikator : [],
                list_Renstra: [],
                list_Renstra_Misi: [],
                list_RPJMD : [],
                list_tujuan : [],
                list_data : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',

                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;


            this.getData();
            this.getRenstra();
            this.getRPJMD();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify({

                        id_renstra : this.id_renstra,
                        rpjmd_id : this.rpjmd_id,
                        renstra_misi_id : this.renstra_misi_id,
                        tujuan_id : this.tujuan_id,
                        no_renstra_tujuan : this.no_renstra_tujuan,
                        uraian : this.uraian,
                        keterangan : this.keterangan,
                        unit_kerja : this.unit_kerja,
                    })
                }).then(res => res.json()).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke : this.page_first,
                        cari_value : this.cari_value,
                        id_renstra : this.id_renstra,
                        unit_kerja : this.unit_kerja,
                        renstra_misi_id : this.renstra_misi_id,
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data.data;
                  this.page_last = res_data.jml_data;
                //   console.log(res_data);
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        renstra_tujuan_id : this.renstra_tujuan_id,

                        id_renstra : this.id_renstra,
                        rpjmd_id : this.rpjmd_id,
                        renstra_misi_id : this.renstra_misi_id_edit,
                        tujuan_id : this.tujuan_id,
                        no_renstra_tujuan : this.no_renstra_tujuan,
                        uraian : this.uraian,
                        keterangan : this.keterangan,
                        unit_kerja : this.unit_kerja_edit,
                    })
                }).then((res_data) => {
                //   console.log(res_data);
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
                console.log(data)
                
                this.renstra_tujuan_id = data.renstra_tujuan_id;
                this.rpjmd_id = data.rpjmd_id;
                this.tujuan_id = data.tujuan_id;

                this.id_renstra = data.id_renstra;
                this.renstra_misi_id_edit = data.renstra_misi_id;

                this.no_renstra_tujuan = data.no_renstra_tujuan;
                this.uraian = data.uraian;
                this.keterangan = data.keterangan;

                this.unit_kerja_edit = data.unit_kerja;
                this.getTujuan();
                this.getIndikator()
                this.getRenstraMisi();
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.kebikan_umum_id = '';
                this.no_kebikan_umum = '';
                this.uraian = '';

                this.list_indikator = [];
            },

        //TAMBAHAN
            getRPJMD : function(){
                fetch(ADD_URL_RPJMD, {
                    method : 'GET',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    }
                }).then(res => res.json()).then((res_data)=>{
                    this.list_RPJMD = res_data;
                })
            },
            getTujuan : function(){
                if (this.rpjmd_id == '') { this.misi_id =''} // Agar ketika pilih Periode RPJMD = 'semua periode' maka semua data akan tampil
                fetch(ADD_URL_TUJUAN, {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara '+localStorage.token
                    },
                    body : JSON.stringify({
                        rpjmd_id : this.rpjmd_id
                    })
                }).then(res => res.json()).then((res_data)=>{
                    this.list_tujuan = res_data;
                    // console.log(res_data);
                })
            },

            getRenstra : function(){
                this.page_first = 1;
                fetch(ADD_URL_RENSTRA, {
                    method : 'POST',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.unit_kerja
                    })
                }).then(res => res.json()).then((res_data)=>{
                    this.list_Renstra = res_data;
                    this.getData();
                    // console.log(res_data);
                })
            },
            getRenstraMisi : function(){
                this.page_first = 1;
                this.list_Renstra_Misi = [];
                if (this.id_renstra == '') {
                    this.renstra_misi_id = ''; 
                } else{
                    fetch(ADD_URL_RENSTRA_MISI, {
                        method : 'POST',
                        headers : {
                            'content-type': 'application/json',
                            authorization : 'kikensbatara '+ localStorage.token
                        },
                        body : JSON.stringify({
                            unit_kerja : this.unit_kerja
                        })
                    }).then(res => res.json()).then((res_data)=>{
                        this.list_Renstra_Misi = res_data;
                        console.log(res_data);
                    })
                }
            },

            addIndikator : function(){
                fetch(ADD_URL+'createDataIndikator', {
                    method : 'POST',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    },
                    body : JSON.stringify({
                        renstra_tujuan_id : this.renstra_tujuan_id,
                        unit_kerja : this.unit_kerja_edit,
                        renstra_indikator_tujuan_id : this.renstra_indikator_tujuan_id,
                        no_indikator : this.no_indikator,
                        uraian_indikator : this.uraian_indikator,
                        satuan : this.satuan,
                        rumus_satuan : this.rumus_satuan,
                        capaian_awal : this.capaian_awal,
                        kondisi_akhir : this.kondisi_akhir,
                    })
                }).then(res => res.json()).then((res_data)=>{
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getIndikator();
                    // console.log(res_data);
                })
            },
            editIndikator : function(){
                fetch(ADD_URL+'updateDataIndikator', {
                    method : 'POST',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    },
                    body : JSON.stringify({
                        renstra_indikator_tujuan_id : this.renstra_indikator_tujuan_id,
                        no_indikator : this.no_indikator,
                        uraian_indikator : this.uraian_indikator,
                        satuan : this.satuan,
                        rumus_satuan : this.rumus_satuan,
                        capaian_awal : this.capaian_awal,
                        kondisi_akhir : this.kondisi_akhir,
                    })
                }).then(res => res.json()).then((res_data)=>{
                    this.alertku('success', 'Berhasil Memperbaharui Data!');
                    this.getIndikator();
                })
            },
            getIndikator : function(){
                fetch(ADD_URL+'getDataIndikator', {
                    method : 'POST',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    },
                    body : JSON.stringify({
                        renstra_tujuan_id : this.renstra_tujuan_id,
                    })
                }).then(res => res.json()).then((res_data)=>{
                    this.list_indikator = res_data;
                    // console.log(res_data);
                })
            },
            selectIndikator : function(data){
                // console.log(data);
                this.renstra_indikator_tujuan_id = data.renstra_indikator_tujuan_id;
                this.no_indikator = data.no_indikator;
                this.uraian_indikator = data.uraian;
                this.satuan = data.satuan;
                this.rumus_satuan = data.rumus_satuan;
                this.capaian_awal = data.capaian_awal;
                this.kondisi_akhir = data.kondisi_akhir;
            },
            removeDataIndikator : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteDataIndikator", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getIndikator();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.getRenstra();
                // console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            btn_check_data_add : function(){
                if (this.id_renstra != '' && this.renstra_misi_id != '') {
                    this.check_data_add = true;
                }
            } ,
            cek_error_data : function(data){
                    if (data == '' || data == null || data == undefined) {
                        return 'background : #ffd9cc'
                    } else {
                        return ''
                    }
                },
        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
